import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-indigo-900 via-indigo-800 to-purple-900 text-white py-4 px-6">
      <div className="container mx-auto">
        <div className="text-center">
          <p className="text-sm font-medium opacity-90">
            © 2025 Tieup Solutions Pvt. Ltd., All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;